<template>
  <div class="results-container">
    <div class="results rr-list">
      <v-depot-item
        v-if="depot_selected"
        @onBookClick="onBookClick($event, depot_selected)"
        :model="depot_selected"
        :selected="true"
        :active="true"
        :padding="true"
        :key="`selected-depot-${depot_selected.state.available_vehicles.map(item => `-${item.id}`)}`"
      />

      <div v-if="models">
        <v-depot-item
          @onDepotClick="onItemClick"
          @onBookClick="onBookClick($event, model)"
          v-for="model in models"
          :key="model.id"
          :model="model"
          :padding="true"
          :class="depot_selected && depot_selected.id == model.id ? 'hide' : null"
        />
      </div>

      <div
        text-center
        margin-top
        class="p-4"
        v-if="!depot_selected && (!models || !models.length)"
      >{{ i18n.app.components.depot.make_a_selection }}</div>
    </div>
  </div>
</template>

<script>
import DepotItem from "./DepotItem";

export default {
  name: "depot-list",
  props: ["models", "depot_selected"],
  components: {
    "v-depot-item": DepotItem
  },
  methods: {
    onItemClick(model) {
      this.$emit("onItemClick", model);
    },
    onBookClick(vehicle, depot) {
      this.$emit("onBookClick", {vehicle, depot});
    }
  }
};
</script>
